import { render, staticRenderFns } from "./projectsTransfer.vue?vue&type=template&id=150c85f6"
import script from "./projectsTransfer.vue?vue&type=script&lang=js"
export * from "./projectsTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports